'use client'
import { useEffect, useState } from 'react'
import s from './Projects.module.scss'
import { Status, Region, Typology } from '@/types/singles/category'
import { Image } from '@/types/common/ImageData'
import ProjectsGridComponent from './grid'
import ProjectsListComponent from './list'
import ProjectsFilterComponent from './filter'
import { set } from 'sanity'

interface ProjectsListProps {
    projects: Array<DataProps>;
    layout: Array<string> | null;
    typologies: Array<Typology>;
    status: Array<Status>;
    regions: Array<Region>;
}

interface ImageProp {
    image: Image;
}

interface DataProps {
    title: string;
    slug: string;
    year: string;
    featuredImage: ImageProp;
    featuredImageHover: ImageProp | null;
    location: string | null;
    typologies: Array<Typology>;
    status: string | null;
    region: string | null;
}

export default function ProjectsComponent({ 
    projects, 
    layout, 
    status, 
    regions, 
    typologies 
}: ProjectsListProps) {

    const [filterStatus, setFilterStatus] = useState<Array<string>>(['ALL']);
    const [filterRegion, setFilterRegion] = useState<Array<string>>(['ALL']);
    const [filterTypology, setFilterTypology] = useState<Array<string>>(['ALL']);
    const [filtered, setFiltered] = useState<boolean>(false);
    const [filteredProjects, setFilteredProjects] = useState<Array<DataProps>>(projects);

    const [selectedDisplay, setSelectedDisplay] = useState('grid');

    // Función para aplicar los filtros
    useEffect(() => {
        const updatedProjects = projects.filter(project => {
            // Si "ALL" está seleccionado en una categoría, no filtramos por ella
            const statusMatch = filterStatus.includes("ALL") || (project.status && filterStatus.includes(project.status));
            const regionMatch = filterRegion.includes("ALL") || (project.region && filterRegion.includes(project.region));
            const typologyMatch = filterTypology.includes("ALL") || (project.typologies ?? []).some(t => filterTypology.includes(t.title));

            if(filterStatus.includes("ALL") && filterRegion.includes("ALL") && filterTypology.includes("ALL")) {
                setFiltered(false);
            } else {    
                setFiltered(true);
            }
            
            return statusMatch && regionMatch && typologyMatch;
        });
        setFilteredProjects(updatedProjects);

        window.scrollTo({ top: 0 });

    }, [filterStatus, filterRegion, filterTypology, projects, setFiltered]);
    

    return (
        <div className={s.projectsList}>
            <div className={s.blankSpace}></div>
            <ProjectsFilterComponent 
                status={status}
                regions={regions}
                typologies={typologies}
                onFilterChange={(filters) => {
                    // Aquí puedes actualizar los estados según corresponda
                    setFilterStatus(filters.status || ['ALL']);
                    setFilterRegion(filters.regions || ['ALL']);
                    setFilterTypology(filters.typologies || ['ALL']);
                }}
                filterStatus={filterStatus}
                filterRegion={filterRegion}
                filterTypology={filterTypology}
                selectedDisplay={selectedDisplay}
                setSelectedDisplay={setSelectedDisplay}
            />
            {selectedDisplay === 'grid' && (
                <ProjectsGridComponent projects={filteredProjects} layout={layout} defaultGrid={filtered}/>
            )}
            {selectedDisplay === 'list' && (
                <ProjectsListComponent projects={filteredProjects} />
            )}
        </div>
    );
    
}